import { render, staticRenderFns } from "./Catalogue.vue?vue&type=template&id=4ee19941&scoped=true&"
import script from "./Catalogue.vue?vue&type=script&lang=ts&"
export * from "./Catalogue.vue?vue&type=script&lang=ts&"
import style0 from "./Catalogue.vue?vue&type=style&index=0&id=4ee19941&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee19941",
  null
  
)

export default component.exports